import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from './environments/current';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
} else {
  console.log('Dev Mode');
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
